// src/utils/socialEnumLabels.js
// Display-only translations for the Social Media Content Management enums.
// Firestore values stay in canonical English; only the rendered label changes.

export const STATUS_LABELS = {
  en: {
    'New Request': 'New Request',
    'Content Writing': 'Content Writing',
    'Content Ready': 'Content Ready',
    'Design / Editing': 'Design / Editing',
    'Design Ready': 'Design Ready',
    'Internal Review': 'Internal Review',
    'Changes Requested': 'Changes Requested',
    'Ready for Client Approval': 'Ready for Client Approval',
    'Client Approval': 'Client Approval',
    'Approved': 'Approved',
    'Scheduled': 'Scheduled',
    'Published': 'Published',
    'Cancelled': 'Cancelled',
  },
  ar: {
    'New Request': 'طلب جديد',
    'Content Writing': 'كتابة المحتوى',
    'Content Ready': 'المحتوى جاهز',
    'Design / Editing': 'التصميم / التعديل',
    'Design Ready': 'التصميم جاهز',
    'Internal Review': 'مراجعة داخلية',
    'Changes Requested': 'طلب تعديلات',
    'Ready for Client Approval': 'جاهز لموافقة العميل',
    'Client Approval': 'موافقة العميل',
    'Approved': 'تمت الموافقة',
    'Scheduled': 'مجدول',
    'Published': 'تم النشر',
    'Cancelled': 'ملغى',
  },
};

export const PLATFORM_LABELS = {
  en: {
    'Facebook': 'Facebook',
    'Instagram': 'Instagram',
    'TikTok': 'TikTok',
    'LinkedIn': 'LinkedIn',
    'X': 'X',
    'YouTube': 'YouTube',
    'WhatsApp Channel': 'WhatsApp Channel',
  },
  ar: {
    'Facebook': 'فيسبوك',
    'Instagram': 'انستغرام',
    'TikTok': 'تيك توك',
    'LinkedIn': 'لينكدإن',
    'X': 'إكس',
    'YouTube': 'يوتيوب',
    'WhatsApp Channel': 'قناة واتساب',
  },
};

export const CONTENT_TYPE_LABELS = {
  en: {
    'Post': 'Post',
    'Reel': 'Reel',
    'Video': 'Video',
    'Story': 'Story',
    'Carousel': 'Carousel',
    'Cover': 'Cover',
    'Ad Creative': 'Ad Creative',
    'Campaign Content': 'Campaign Content',
  },
  ar: {
    'Post': 'منشور',
    'Reel': 'ريل',
    'Video': 'فيديو',
    'Story': 'ستوري',
    'Carousel': 'كاروسيل',
    'Cover': 'غلاف',
    'Ad Creative': 'تصميم إعلاني',
    'Campaign Content': 'محتوى حملة',
  },
};

export const getStatusLabel = (status, language) =>
  STATUS_LABELS[language]?.[status] || status;

// A content task can target more than one platform at once, stored as a single
// " + "-joined string (e.g. "Facebook + Instagram") for backward compatibility with
// older single-platform code paths. Translate each segment individually.
export const getPlatformLabel = (platform, language) => {
  if (!platform) return platform;
  if (platform.includes(' + ')) {
    return platform.split(' + ').map((p) => PLATFORM_LABELS[language]?.[p] || p).join(' + ');
  }
  return PLATFORM_LABELS[language]?.[platform] || platform;
};

export const getContentTypeLabel = (contentType, language) =>
  CONTENT_TYPE_LABELS[language]?.[contentType] || contentType;
